import { CoverImage, Fonts, Image, Text, TextSize, Weight } from 'components'
import styled from 'styled-components'
import { css } from 'styled-components'
import { GLOBAL_COLORS } from 'theme'

export const CoverOverview = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 75px;
`

export const BgWrapper = styled.div`
  height: 30px;
  display: flex;
  align-items: center;
  gap: 9px;
  box-sizing: border-box;
  ${({ theme }) => theme.mediaWidth.Mobile`
    flex-direction: column;
    height: auto;
    align-items: flex-start;
  `}
`

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

/**
 * Styling to show the network badge
 * TODO: dynamic sizing based on screen size
 */
export const NetworkImage = styled(CoverImage)`
  ${({ theme }) => theme.mediaWidth.Desktop`
 height: 32px;
 width: 32px;
`};
  margin-right: 10px;
  backdrop-filter: blur(1px);
  border-radius: 4px;
  border: 1px solid ${GLOBAL_COLORS.seashellWhite};
`

export const CustomIcon = styled(Image)`
  height: 24px;
  width: 24px;
  border-radius: 50%;
  ${({ theme }) => theme.mediaWidth.Tablet`
    height: 64px;
    width: 64px;
  `}
  ${({ theme }) => theme.mediaWidth.Mobile`
    height: 64px;
    width: 64px;
  `}
`

export const TextWrapper = styled.div`
  display: flex;
`

export const Title = styled(Text)`
  margin-right: 5px;
  font-size: ${TextSize.two};
  font-weight: ${Weight.Bold};
  ${({ theme }) => theme.mediaWidth.Tablet`
    font-size: ${TextSize.nav};
  `}
`
export const IndexInfo = styled(Text)`
  font-size: ${TextSize.two};
  font-weight: ${Weight.Regular};
  ${({ theme }) => theme.mediaWidth.Tablet`
    font-size: ${TextSize.nav};
  `}
`

export const GradientTextWrapper = styled.div`
  margin-top: 20px;
  ${({ theme }) => theme.mediaWidth.Tablet`
    margin-top: 20px;
  `}
`

export const RegularText = styled(Text)`
  font-size: ${TextSize.h4};
  font-weight: ${Weight.Bold};
  letter-spacing: -0.04em;
  line-height: 42px;
  margin-top: 20px;
  ${({ theme }) => theme.mediaWidth.Tablet`
    font-size: 28px;
    line-height: 32px;
  `}
`

export const GradientText = styled.span<{
  isCapitalized: boolean
  firstColor: string
  secondColor: string
}>`
  font-size: ${TextSize.h4};
  font-weight: ${Weight.Bold};
  font-family: ${Fonts.DMSans};
  letter-spacing: -0.04em;
  line-height: 45px;
  background: ${({ firstColor, secondColor }) =>
    `linear-gradient(115.67deg, ${firstColor} 14.84%, ${secondColor} 42.97%, ${secondColor} 103.1%, ${secondColor}88 103.1%)`};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  ${({ isCapitalized }) =>
    isCapitalized &&
    css`
      :first-letter {
        text-transform: capitalize;
      }
    `}
  ${({ theme }) => theme.mediaWidth.Tablet`
    font-size: 28px;
    line-height: 32px;
  `}
`

export const DescriptionText = styled(Text)`
  font-size: ${TextSize.small};
  font-weight: ${Weight.Regular};
  margin-top: 20px;
  color: ${({ theme }) => theme.secondaryText};
`

export const SeparatorLine = styled.div`
  opacity: 0.6;
  height: 1px;
  width: 100%;
  background-color: ${GLOBAL_COLORS.separatorBg};
  margin: 20px 0;
`

export const MainInfoContainer = styled.div`
  display: flex;
  gap: 40px;
  margin-top: 5px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    gap: 0;
    justify-content: space-between;
  `}
`
export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`
export const InfoTitle = styled(Text)`
  font-size: ${TextSize.small};
  font-weight: ${Weight.Regular};
`
export const InfoValue = styled(Text)`
  font-size: ${TextSize.p};
  font-weight: ${Weight.Bold};
`
